import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { TestWarehouse } from "hooks/useCurrentUser";
import { useEffect, useState } from "react";
import { useRevalidator } from "react-router-dom";
import { api } from "services/api.service";

// Shown only when the API says the signed-in user may pick a warehouse, which it does in development and staging.
export function TestWarehouseSelect({
  warehouseId,
  warehouses,
}: {
  warehouseId: number | null;
  warehouses: TestWarehouse[];
}) {
  const revalidator = useRevalidator();
  const [selected, setSelected] = useState(warehouseId ? String(warehouseId) : "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setSelected(warehouseId ? String(warehouseId) : "");
  }, [warehouseId]);

  async function handleChange(value: string) {
    const previous = selected;
    setSelected(value);
    setSaving(true);
    try {
      await api.patch("/current_user/warehouse", { warehouseId: Number(value) });
      revalidator.revalidate();
    } catch {
      setSelected(previous);
    } finally {
      setSaving(false);
    }
  }

  return (
    <FormControl size="small" fullWidth disabled={saving} sx={{ mt: 0.5, minWidth: 160 }}>
      <InputLabel id="test-warehouse-label">Warehouse</InputLabel>
      <Select
        labelId="test-warehouse-label"
        label="Warehouse"
        value={selected}
        onChange={(event) => handleChange(event.target.value)}
      >
        {warehouses.map((warehouse) => (
          <MenuItem key={warehouse.id} value={String(warehouse.id)}>
            {warehouse.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
